<template>
  <div
    v-click-outside="hideConversationList"
    :class="{opened: conversationListOpened}"
    class="conversations-box">
    <span
      class="conversation-toggle-button"
      @click="toggleConversationList">
      <icon
        v-if="conversationListOpened"
        name="chevron-left"/>
      <icon
        v-else
        name="list-ul"/>
    </span>
    <div class="action-box clearfix">
      <div class="action-item folders">
        <span
          class="action-button action-folders"
          @click="toggleFolderList">
          <p class="nav d-inline-block">
            <img
              v-if="folder === 'open'"
              src="~@/assets/img/chat-open.svg">
            <img
              v-if="folder === 'done'"
              src="~@/assets/img/check-circle.svg">
            <img
              v-if="folder === 'spam'"
              src="~@/assets/img/trash-bin.svg">
            {{ folder }}
            <span class="dot">&#183;</span>
            {{ assignmentFolderNames[assignmentFolder] }}
          </p>
          <span
            :class="{opened: showFolderList}"
            class="arrow">
            <icon name="chevron-down"/>
          </span>
          <span
            v-if="userHasUnreadMessages"
            class="message-received-dot"/>
        </span>
        <div
          v-if="showFolderList"
          class="folder-list">
          <div
            :class="{active: ((folder === 'open') && (assignmentFolder === 'all')), 'has-unread': statistics.open.all_unread}"
            class="folder-select open"
            @click="selectMessageFolder('open')">
            <img src="~@/assets/img/chat-open.svg">
            <p>Open <span class="count">{{ statistics.open.all }}</span></p>
          </div>
          <div
            v-if="folder === 'open'"
            class="sub-folders">
            <div
              :class="{active: assignmentFolder === 'unassigned', 'has-unread': statistics.open.unassigned_unread}"
              class="folder-select"
              @click="changeAssignmentFolder('unassigned')">
              <img src="~@/assets/img/question-circle.svg">
              <p>Unassigned <span class="count">{{ statistics.open.unassigned }}</span></p>
            </div>
            <div
              :class="{active: assignmentFolder === 'user_assigned', 'has-unread': statistics.open.user_unread[userId]}"
              class="folder-select"
              @click="changeAssignmentFolder('user_assigned')">
              <img src="~@/assets/img/user-circle.svg">
              <p>You <span class="count">{{ statistics.open.user_assigned[userId] || 0 }}</span></p>
            </div>
          </div>
          <div
            :class="{active: ((folder === 'done') && (assignmentFolder === 'all'))}"
            class="folder-select done"
            @click="selectMessageFolder('done')">
            <img src="~@/assets/img/check-circle.svg">
            <p>Done</p>
          </div>
          <div
            v-if="folder === 'done'"
            class="sub-folders">
            <div
              :class="{active: assignmentFolder === 'unassigned'}"
              class="folder-select"
              @click="changeAssignmentFolder('unassigned')">
              <img src="~@/assets/img/question-circle.svg">
              <p>Unassigned</p>
            </div>
            <div
              :class="{active: assignmentFolder === 'user_assigned'}"
              class="folder-select"
              @click="changeAssignmentFolder('user_assigned')">
              <img src="~@/assets/img/user-circle.svg">
              <p>You</p>
            </div>
          </div>
          <div
            class="folder-select spam"
            @click="selectMessageFolder('spam')">
            <img src="~@/assets/img/trash-bin.svg">
            <p>Spam</p>
          </div>
        </div>
      </div>
      <div class="action-item search-cont">
        <span
          class="action-button search"
          @click="showSearch">
          <img src="~@/assets/img/search-icon-light.svg">
        </span>
        <div
          v-if="showSearchForm"
          class="search-form">
          <span
            class="search-action close"
            @click="hideSearch">
            <icon
              name="times"
              class="float-left"/>
          </span>
          <b-input
            ref="searchInput"
            v-model="searchQuery"
            placeholder="Search contacts..."
            @change="searchConversations"/>
          <span class="search-action">
            <img
              src="~@/assets/img/search-icon-active.svg"
              class="float-right"
              @click="searchConversations">
          </span>
        </div>
      </div>
    </div>
    <b-row
      v-if="showSearchForm"
      class="search-folders">
      <b-button-group>
        <b-button
          :class="{active: folder === 'open'}"
          :disabled="folder === 'open'"
          class="btn btn-main"
          @click="selectMessageFolder('open')">Open</b-button>
        <b-button
          :class="{active: folder === 'done'}"
          :disabled="folder === 'done'"
          class="btn btn-main"
          @click="selectMessageFolder('done')">Done</b-button>
        <b-button
          :class="{active: folder === 'spam'}"
          :disabled="folder === 'spam'"
          class="btn btn-main"
          @click="selectMessageFolder('spam')">Spam</b-button>
      </b-button-group>
    </b-row>
    <!--<b-row
      v-if="(folder !== 'spam') && !showSearchForm"
      class="assignment-box">
      <b-col
        :class="{active : assignmentFolder === 'all'}"
        cols="4"
        class="assignment-option"
        @click="changeAssignmentFolder('all')">
        <h4>{{ statistics[folder].all }}</h4>
        <p>All</p>
        <span class="has-unread"><span
          v-if="statistics.open.all_unread && (folder === 'open')"
          class="unread-count-dot">{{ statistics.open.all_unread }}</span></span>
      </b-col>
      <b-col
        :class="{active : assignmentFolder === 'unassigned'}"
        cols="4"
        class="assignment-option"
        @click="changeAssignmentFolder('unassigned')">
        <h4>{{ statistics[folder].unassigned }}</h4>
        <p>Unassigned</p>
        <span class="has-unread"><span
          v-if="statistics.open.unassigned_unread && (folder === 'open')"
          class="unread-count-dot">{{ statistics.open.unassigned_unread }}</span></span>
      </b-col>
      <b-col
        :class="{active : assignmentFolder === 'user_assigned'}"
        cols="4"
        class="assignment-option"
        @click="changeAssignmentFolder('user_assigned')">
        <h4>{{ statistics[folder].user_assigned[userId] || 0 }}</h4>
        <p>You</p>
        <span class="has-unread"><span
          v-if="statistics.open.user_unread[userId] && (folder === 'open')"
          class="unread-count-dot">{{ statistics.open.user_unread[userId] }}</span></span>
      </b-col>
    </b-row>-->
    <ScrollArea
      ref="conversationScrollbar"
      :class="{'height-md': showSearchForm}"
      class="inbox-chat-container"
      @bottom="handleBottomScroll">
      <div class="inbox-chat-list">
        <template v-if="conversationsLoad.loaded || (!conversationsLoad.loaded && (page !== 1))">
          <transition-group
            name="conversation-list"
            tag="div">
            <div
              v-for="conversation in conversations"
              :key="conversation.id"
              :class="{
                'active-chat' : (currentConversation && (currentConversation.id === conversation.id)),
                'not-seen': conversationIsUnread(conversation),
                'changed-activity': !!conversation.changed_activity,
              }"
              class="chat-details"
              @click="changeCurrentConversation(conversation)">
              <div class="chat-user">
                <img
                  :src="`/static/img/avatars/user-chat-icon-${conversation.contact.avatar}.svg`"
                  class="avatar img-responsive rounded-circle">
                <div class="chat-user-info">
                  <h5>
                    {{ conversation.contact.name ? conversation.contact.name : conversation.contact.phone }}
                    <span class="chat-date">
                      {{ newestDate(conversation) | dateDiff }}
                    </span>
                  </h5>
                  <p>
                    <span v-if="['outbound', 'outbound-api'].includes(conversation.message_direction)">You: </span>
                    <span v-if="['bot', 'outbound-reply'].includes(conversation.message_direction)">Bot: </span>
                    <MessageContent :content="conversation.last_message"/>
                  </p>
                </div>
              </div>
              <span
                v-if="!conversation.changed_activity"
                class="assignee-name">{{ findAssigneeName(conversation.user_id) }}</span>
              <span
                v-else
                class="changed-activity-message">{{ conversation.changed_activity.text }}</span>
            </div>
          </transition-group>
        </template>
        <div
          v-if="!conversationsLoad.loaded"
          :class="{'loader-main': page === 1}"
          class="loader">
          <div class="loading-circle"/>
        </div>
        <div
          v-if="conversationsLoad.loaded && (page !== 1) && (page >= lastPage)"
          class="no-more-data">No more conversations.</div>
        <div
          v-if="conversationsLoad.loaded && !conversations.length"
          class="no-conversations">
          <div class="info">
            <img src="~@/assets/img/no-user-list.svg">
            <h6>
              No conversations to show
            </h6>
          </div>
        </div>
      </div>
    </ScrollArea>
  </div>
</template>

<script>
import ClickOutside from 'v-click-outside';
import { mapActions, mapGetters } from 'vuex';
import NotificationSoundMixin from '@/mixins/NotificationSound';
import ScrollArea from '../../common/ScrollArea';
import MessageContent from '../../common/MessageContent';

export default {
  name: 'Conversations',
  components: {
    ScrollArea,
    MessageContent,
  },
  directives: {
    ClickOutside: ClickOutside.directive,
  },
  mixins: [NotificationSoundMixin],
  data() {
    return {
      conversations: {},
      currentConversation: {},
      userId: localStorage.getItem('userId'),
      savedConversationId: false,
      showFolderList: false,
      showSearchForm: false,
      assignmentDot: false,
      folder: 'open',
      assignmentFolder: 'all',
      searchQuery: '',
      page: 1,
      limit: 25,
      searchExecuted: true,
      lastPage: false,
      connectionFailure: false,
      conversationListOpened: false,
      assignmentFolderNames: {
        all: 'All',
        unassigned: 'Unassigned',
        user_assigned: 'You',
      },
    };
  },
  computed: {
    ...mapGetters({
      conversationList: 'chat/conversationList',
      statistics: 'chat/statistics',
      members: 'merchant/members',
      conversationSeen: 'chat/conversationSeen',
      unreadConversationsCount: 'chat/unreadConversationsCount',
      newMessageConversation: 'pusher/newMessageConversation',
      newConversationActivity: 'pusher/newConversationActivity',
      conversationsLoad: 'chat/conversationsLoad',
      echoConnectionLost: 'pusher/echoConnectionLost',
      apiError: 'chat/apiError',
    }),
    userHasUnreadMessages() {
      return !!this.statistics.open.all_unread || !!this.statistics.open.user_unread[this.userId];
    },
  },
  watch: {
    conversationsLoad(load) {
      if (load.loaded) {
        if (this.page === 1) {
          this.conversations = this.conversationList.data;
          if (this.$lodash.isEmpty(this.conversations)) {
            return;
          }
          if (!this.savedConversationId) {
            this.currentConversation = this.$lodash.head(this.conversations);
          } else {
            this.currentConversation = this.$lodash.find(this.conversations,
              conversation => conversation.id === this.savedConversationId);
            if (!this.currentConversation) {
              this.currentConversation = this.$lodash.head(this.conversations);
            }
          }
          this.savedConversationId = false;
        } else {
          this.conversations = this.$lodash.concat(this.conversations, this.conversationList.data);
        }
        this.lastPage = this.conversationList.meta.last_page;
      }
    },
    echoConnectionLost(connectionLost) {
      if (connectionLost) {
        this.connectionFailure = true;
      } else {
        this.connectionFailure = false;
        this.savedConversationId = this.currentConversation.id;
        this.resetPagination();
        this.loadConversations();
      }
    },
    currentConversation(conversation) {
      this.conversations = this.$lodash.filter(this.conversations, conversation => !conversation.changed_activity);
      this.$emit('conversationChanged', conversation);
    },
    conversationSeen(conversationData) {
      if (conversationData) {
        const index = this.$lodash.findIndex(this.conversations, { id: conversationData.id });
        if (index !== -1) {
          this.conversations[index].seen = conversationData.seen;
          this.conversations[index].assignment_seen = conversationData.assignment_seen;
          if ((this.currentConversation.id === conversationData.id)) {
            this.currentConversation.seen = conversationData.seen;
          }
        }
      }
    },
    unreadConversationsCount(unreadData) {
      if (!this.$lodash.isEmpty(unreadData)) {
        this.statistics.open.all_unread = unreadData.unread_conversations.all_unread;
        this.statistics.open.user_unread = unreadData.unread_conversations.user_unread;
        this.statistics.open.unassigned_unread = unreadData.unread_conversations.unassigned_unread;
        this.setStatistics(this.statistics);
      }
    },
    newMessageConversation(payload) {
      const conversation = payload.conversation;
      this.setStatistics(payload.merchant_conversation_statistics);
      if (!this.$lodash.isEmpty(this.conversations)) {
        this.conversations = this.$lodash.filter(this.conversations, conversationItem => conversationItem.id !== conversation.id);
      }

      if (this.currentConversation.id !== conversation.id) {
        this.notifySound();
      } else if (conversation.message_direction === 'inbound') {
        this.$set(this.currentConversation, 'inbound_sent_at', conversation.inbound_sent_at);
        if (document.hidden) {
          this.notifySound();
        }
      }

      if (this.folder === 'open') {
        if (
          (this.assignmentFolder === 'all') ||
          ((this.assignmentFolder === 'unassigned') && (conversation.user_id === null)) ||
          ((this.assignmentFolder === 'user_assigned') && (conversation.user_id === this.userId))
        ) {
          this.conversations.unshift(conversation);
        }
        if ((this.currentConversation.id === conversation.id) && (conversation.message_direction === 'inbound')) {
          this.currentConversation.seen = false;
        }
      } else if ((this.currentConversation.id === conversation.id) && (this.folder === 'done')) {
        this.conversations.unshift(conversation);
        this.addFolderChangedActivity(conversation.id, 'open');
      } else {
        // Do not jump to the first message in the conversations
        // this.currentConversation = this.$lodash.head(this.conversations) || false;   // VM reminder
      }
    },
    folder(folder) {
      this.$emit('folderChanged', folder);
    },
    searchQuery() {
      this.searchExecuted = false;
    },
    newConversationActivity(payload) {
      const activity = payload.activity;
      const activityConversation = payload.conversation;
      switch (activity.action) {
        case 'folder': {
          this.handleFolderActivity(activity, activityConversation);
          break;
        }
        case 'assignment': {
          this.handleAssignmentActivity(activity, activityConversation);
          break;
        }
        default:
          break;
      }

      this.setStatistics(payload.merchant_conversation_statistics);
    },
    assignmentFolder(assignment) {
      this.resetPagination();
      this.$emit('assignmentFolderChanged', assignment);
      this.loadConversations();
    },
  },
  mounted() {
    if (this.$route.params.search_query) {
      this.setContactSearchRouteParams();
    }

    this.fetchStatistics(this.$route.params.merchant_id);
    this.loadConversations();

    this.$eventBus.$on('newmessagesent', () => {
      this.conversations = this.$lodash.orderBy(this.conversations, 'message_sent_at', 'desc');
    });

    this.$eventBus.$on('contactDataChanged', (payload) => {
      const conversation = this.$lodash.find(this.conversations,
        conversation => conversation.id === payload.conversation_id);
      if (conversation) {
        conversation.contact = payload.contact;
      }
    });
  },
  methods: {
    ...mapActions({
      fetchConversations: 'chat/fetchConversations',
      fetchStatistics: 'chat/fetchStatistics',
      setStatistics: 'chat/setStatistics',
      // updateChatStatus: 'chat/updateStatus',
    }),
    loadConversations(removeCurrent = true) {
      if (removeCurrent) {
        this.currentConversation = false;
      }
      const payload = {
        merchant_id: this.$route.params.merchant_id,
        filters: {
          page: this.page,
          limit: this.limit,
          folder: this.folder,
          assignment: this.assignmentFolder,
          search_query: this.searchQuery,
        },
      };
      this.fetchConversations(payload);
    },
    loadMoreConversations() {
      if (this.conversationsLoad.loaded && (this.page < this.lastPage)) {
        this.page += 1;
        this.loadConversations(false);
      }
    },
    searchConversations() {
      this.searchExecuted = true;
      this.resetPagination();
      this.assignmentFolder = 'all';
      this.loadConversations();
    },
    setContactSearchRouteParams() {
      this.searchQuery = this.$route.params.search_query;
      this.folder = this.$route.params.folder;
      this.showSearchForm = true;
    },
    changeCurrentConversation(conversation) {
      this.currentConversation = conversation;
      this.conversationListOpened = false;
    },
    handleAssignmentActivity(activity, activityConversation) {
      if (!this.conversations.length && (
        ((this.assignmentFolder === 'unassigned') && !activity.to_user_id) ||
        ((this.assignmentFolder === 'user_assigned') && activity.to_user_id === this.userId)
      )) {
        this.conversations.unshift(activityConversation);
        this.currentConversation = activityConversation;
        return;
      }

      if (((activity.to_user_id === this.userId) &&
          (this.currentConversation.id !== activityConversation.id)) || (document.hidden)) {
        this.notifySound();
      }

      const index = this.$lodash.findIndex(this.conversations, { id: activityConversation.id });
      if (index === -1) {
        if (
          ((this.assignmentFolder === 'unassigned') && !activity.to_user_id) ||
          ((this.assignmentFolder === 'user_assigned') && activity.to_user_id === this.userId)
        ) {
          this.conversations.unshift(activityConversation);
        }

        return;
      }

      this.conversations[index].user_id = activityConversation.user_id;
      if (activity.to_user_id !== this.userId) {
        this.conversations[index].assignment_seen = false;
      }
      const toUser = activity.to_user_id ? this.$lodash.find(this.members, { id: activity.to_user_id }) : null;
      const activityText = toUser ? `Assigned to ${(this.userId === toUser.id) ? 'you' : toUser.name}` : 'Unassigned';

      if (this.currentConversation.id === activityConversation.id) {
        if (
          ((this.assignmentFolder === 'unassigned') && activity.to_user_id) ||
          ((this.assignmentFolder === 'user_assigned') && (activity.to_user_id !== this.userId))
        ) {
          this.currentConversation.changed_activity = {
            type: 'assignment',
            text: activityText,
          };
          this.$set(this.conversations, index, this.currentConversation);
        } else {
          this.$lodash.unset(this.currentConversation, 'changed_activity');
        }
      } else if (
        ((this.assignmentFolder === 'unassigned') && activity.to_user_id) ||
        ((this.assignmentFolder === 'user_assigned') && (activity.to_user_id !== this.userId))
      ) {
        this.conversations = this.$lodash.filter(this.conversations, conversation => conversation.id !== activityConversation.id);
      } else if (
        ((this.assignmentFolder === 'unassigned') && !activity.to_user_id) ||
        ((this.assignmentFolder === 'user_assigned') && activity.to_user_id === this.userId)
      ) {
        this.conversations.unshift(activityConversation);
      }
    },
    findAssigneeName(userId) {
      if (!userId) {
        return 'Unassigned';
      }

      const user = this.$lodash.find(this.members, { id: userId });
      return user ? user.name : 'Unassigned';
    },
    handleFolderActivity(activity, activityConversation) {
      if (activity.meta_data.new_folder !== this.folder) {
        this.addFolderChangedActivity(activity.conversation_id, activity.meta_data.new_folder);
      } else {
        const conversationExists = this.$lodash.find(this.conversations, { id: activityConversation.id });
        if (conversationExists) {
          this.$lodash.unset(this.currentConversation, 'changed_activity');
          this.$emit('folderActivityChanged');
        } else {
          this.conversations.unshift(activityConversation);
        }
      }
    },
    addFolderChangedActivity(conversationId, folder) {
      if (this.currentConversation.id === conversationId) {
        const index = this.$lodash.findIndex(this.conversations, { id: conversationId });
        const newFolder = folder.replace(/\b\w/g, l => l.toUpperCase());
        this.currentConversation.changed_activity = {
          type: 'folder_changed',
          text: `Moved to ${newFolder}`,
        };
        this.$set(this.conversations, index, this.currentConversation);
        this.$emit('folderActivityChanged');
      } else {
        this.conversations = this.$lodash.filter(this.conversations, conversation => conversation.id !== conversationId);
      }
    },
    conversationIsUnread(conversation) {
      return !conversation.seen || (!conversation.assignment_seen && (conversation.user_id === this.userId));
    },
    resetPagination() {
      this.page = 1;
      this.lastPage = 1;
    },
    showSearch() {
      this.showFolderList = false;
      this.showSearchForm = true;
      this.$nextTick(() => {
        this.$refs.searchInput.focus();
      });
    },
    hideSearch() {
      if ((this.searchQuery === '') && this.searchExecuted) {
        this.showSearchForm = false;
        return;
      }

      this.resetPagination();
      this.assignmentFolder = 'all';
      this.searchQuery = '';
      this.showSearchForm = false;
      this.loadConversations();
    },
    toggleFolderList() {
      this.showFolderList = !this.showFolderList;
    },
    selectMessageFolder(folder) {
      this.showFolderList = false;
      this.folder = folder;
      this.assignmentFolder = 'all';
      this.resetPagination();
      this.loadConversations();
    },
    changeAssignmentFolder(assignment) {
      this.showFolderList = false;
      this.assignmentFolder = assignment;
    },
    hideConversationList() {
      this.conversationListOpened = false;
    },
    toggleConversationList() {
      this.conversationListOpened = !this.conversationListOpened;
    },
    handleBottomScroll() {
      this.loadMoreConversations();
    },
    newestDate(conversation) {
      let newerDate = conversation.inbound_sent_at;
      if (new Date(conversation.inbound_sent_at) < new Date(conversation.message_sent_at)) {
        newerDate = conversation.message_sent_at;
      }
      return newerDate;
    },
  },
};
</script>
